import SashiDo from 'lib/SashiDo';
import AccountManager from 'lib/AccountManager';
import moment from 'moment';
import history from 'dashboard/history';
import Button from 'components/Button/Button.react';

import Gravatar                 from 'react-gravatar';
import Toggle                   from 'components/Toggle/Toggle.react';
import Field                    from 'components/Field/Field.react';
import Fieldset                 from 'components/Fieldset/Fieldset.react';
import FormButton               from 'components/FormButton/FormButton.react';
import FormModal                from 'components/FormModal/FormModal.react';
import FormTable                from 'components/FormTable/FormTable.react';
import KeyField                 from 'components/KeyField/KeyField.react';
import Label                    from 'components/Label/Label.react';
import Modal                    from 'components/Modal/Modal.react';
import React, { Component }     from 'react';
import PreLoader                from 'components/PreLoader/PreLoader.react';
import renderFlowFooterChanges  from 'lib/renderFlowFooterChanges';
import styles                   from 'dashboard/Settings/Settings.scss';
import stylesButton             from 'components/Button/Button.scss';
import TextInput                from 'components/TextInput/TextInput.react';
import Toolbar                  from 'components/Toolbar/Toolbar.react';
import { dateStringUTC }        from 'lib/DateUtils';
import Notification             from 'components/Notification/Notification.react';

export default class AccountInfo extends Component {
  constructor(props) {
    super();

    this.state = {
      loading: false,
      note: null,
      user: {},
      currentPassword: '',
      newPassword: '',
      saveState: null,
      updateSuccess: {},
    };
  }

  changeAvatar(image) {
    AccountManager.changeAvatar(image);
  }

  onClose() {
    this.setState({
      showPolicies: false,
      showTos: false,
    });
  }

  track(type) {
    return SashiDo.activityTrack({ type })
  }

  render() {

    const policiesView =
      this.state.showPolicies &&
        <Modal
          width={740}
          title='Privacy Notice'
          cancelText={'Go Back'}
          onCancel={() => this.onClose()}
        >
          <iframe className={styles.Policies} width='100%' height="100%" src={`https://www.sashido.io/en/policies/dashboard#gdpr-privacy-notice`} />
        </Modal>;

    const tosView =
      this.state.showTos &&
        <Modal
          width={740}
          title='Terms of Service'
          cancelText={'Go Back'}
          onCancel={() => this.onClose()}
        >
          <iframe className={styles.Policies} width='100%' height="100%" src={`https://www.sashido.io/en/policies/dashboard`} />
        </Modal>;

    const { email, use_gravatar, image, name, createdAt } = this.props.currentUser;
    const { first_name, last_name, company, phone, cf_twitter, cf_facebook, } = this.props.currentCustomer.info;
    const { info } = this.props.currentCustomer;

    const accountInfoFields =
      <Fieldset
        legend='Account Info'
        description='Personal information linked to this account.'>
        <div className={styles.settingsBox}>
          <div className={styles.infoBox} style={{ paddingBottom: 0 }}>
            <Notification note={this.state.updateSuccess} close={true} />

            <div className={styles.avatar}>
              {
                use_gravatar
                  ? <Gravatar email={email} size={140} default={'mm'} />
                  : <img src={image || '/assets/images/default-user-avatar.png'} />
              }
            </div>

            <div className={styles.info} style={{ marginTop: -20 }}>
              <Field label={<Label text='Created at' />} input={<KeyField>{moment(this.props.currentUser.createdAt).format('DD MMM YYYY') || ''}</KeyField>} />
              <Field label={<Label text='First Name' />} input={<KeyField>{first_name || ''}</KeyField>} />
              <Field label={<Label text='Last Name' />} input={<KeyField>{last_name}</KeyField>} />
              <Field label={<Label text='Company' />} input={<KeyField>{company || ''}</KeyField>} />
              <Field label={<Label text='Phone' />} input={<KeyField>{phone || ''}</KeyField>} />
              <Field label={<Label text='Twitter' />} input={<KeyField>{cf_twitter || ''}</KeyField>} />
              <Field label={<Label text='Facebook' />} input={<KeyField>{cf_facebook || ''}</KeyField>} />

              <div className={[styles.agree, styles.disabled].join(' ')}>
                <Toggle
                  value={this.props.currentUser.agreeReceiveNewsletter}
                  onChange={(agree) => this.setState({ agreeMail: agree })} />

                  <p>I agree to receive newsletters on my e-mail in accordance with SashiDo's <a href="javascript:;" onClick={() => this.setState({ showTos: true })}>Terms of Service</a> and <a href="javascript:;" onClick={() => this.setState({ showPolicies: true })}>Privacy Notice</a>.</p>
              </div>
            </div>
          </div>

          <div className={styles.hr} style={{ marginTop: 0 }}></div>

          <Field
            label={''}
            input={
              <FormButton
                color='blue'
                value='Update Account Info'
                onClick={() => {
                  history.push('/account/info/update')
                }} />
            } />
        </div>
      </Fieldset>

    const extraFields =
      <Fieldset
        legend='GDPR and Privacy Protection'>
        <div className={styles.settingsBox}>
          <Field
            className='oneliner'
            label={<Label
              className='oneliner'
              text='Right to data portability'
            />}
            input={
              <a
                className={[stylesButton.button, stylesButton.small, stylesButton.blue].join(' ')}
                href='javascript:;'
                onClick={() => this.track('preview_export').then(() => history.push('/account/info/export'))}>
                Request
              </a>
            }
          />

          <div className={styles.hr}></div>

          <Field
            className='oneliner'
            label={<Label
              className='oneliner'
              text='Right to withdraw consent to the processing of personal data'
            />}
            input={
              <a
                className={[stylesButton.button, stylesButton.small, stylesButton.blue].join(' ')}
                href='javascript:;'
                onClick={() => this.track('preview_withdraw').then(() => history.push('/account/info/withdraw'))}>
                Request
              </a>
            }
          />

          <div className={styles.hr}></div>

          <Field
            className='oneliner'
            label={<Label
              className='oneliner'
              text='Right "to be forgotten" - for erasure of personal data related to me'
            />}
            input={
              <a
                className={[stylesButton.button, stylesButton.small, stylesButton.blue].join(' ')}
                href='javascript:;'
                onClick={() => this.track('preview_forgot').then(() => history.push('/account/info/forgot'))}>
                Request
              </a>
            }
          />
        </div>
      </Fieldset>

    const pinFields =
      <Fieldset
        legend='Account PIN Code'
        descriptionWithHTML="You'll use your PIN Code for security, authentication and GDPR purposes.<br />It's crucial to keep your pin code private and secure!">
        <div className={styles.settingsBox}>
          <Field
            label={<Label text='PIN Code' />}
            input={<KeyField name='PIN Code' hidden={true}>{this.props.currentUser.pin}</KeyField>} />
        </div>
      </Fieldset>

    const classes = [styles.settings_page, styles.default];

    return (
      <div className={classes.join(' ')}>
        <Toolbar section={this.props.section} subsection={this.props.subsection} />
        <PreLoader loading={this.state.loading}>
          <div className={styles.holder}>
            {accountInfoFields}
            {extraFields}
            {pinFields}
            {tosView}
            {policiesView}
          </div>
        </PreLoader>
      </div>
    );
  }
}
